import { Injectable } from '@angular/core';

import { IndividualConfig, ToastrService } from 'ngx-toastr';

@Injectable()
export class AppToastrService {

    constructor(private toastr: ToastrService) {
    }

    success(message: string, title?: string, options?: Partial<IndividualConfig>): void {
        this.toastr.success(message, title, this.mergeConfigs(options));
    }

    error(message: string, title?: string, options?: Partial<IndividualConfig>): void {
        this.toastr.error(message, title, this.mergeConfigs(options));
    }

    warning(message: string, title?: string, options?: Partial<IndividualConfig>): void {
        this.toastr.warning(message, title, this.mergeConfigs(options));
    }

    private mergeConfigs(overrideConfigs: Partial<IndividualConfig> = {}): Partial<IndividualConfig> {
        if (overrideConfigs && overrideConfigs.toastClass) {
            overrideConfigs.toastClass += ' ngx-toast'; // to prevent styles crash
        }

        return { ...overrideConfigs };
    }
}
